import { FunctionComponent, ReactElement } from "react";
import ModalOpen from "../modalExportar/components/modal";
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';

interface ModalIncluirProps {
  children?: () => ReactElement
}

const ModalIncluir: FunctionComponent<ModalIncluirProps> = ({ children }) => {

  return (<>
    <ModalOpen title="Adicionar" buttonStyle={{ sx: { boxShadow: 'none', '@media (max-width: 600px)': {
          '> p': {
            display: 'none'
          }
        } }, variant: "contained", startIcon: <AddBoxRoundedIcon /> }}>
      <>
        {
          children
        }
      </>
    </ModalOpen>
  </>);
}

export default ModalIncluir;
